import { Stack } from "@mui/material";
import { NoContentBlock } from "../../ui";

export const NoContactsBlock = () => {
  return (
    <Stack gap="8px" alignItems="center" justifyContent="center" padding="32px">
      <NoContentBlock
        title={"No Matching Contacts"}
        text={
          "No contacts match the current filters. Try changing or clearing them to " +
          "see more results."
        }
      />
    </Stack>
  );
};
